module.exports = __webpack_public_path__ + "static/img/12.5d1b625.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/eng/12.png
// module id = g4/5
// module chunks = 0